<template>
  <div>
    <v-data-table
      :locale="'fr'"
      class="elevation-2 my-4"
      :headers="listHeaders"
      :items="records"
      :loading="isLoadingRecords"
      item-key="id"
      show-expand
      :server-items-length="recordsCount"
      @update:items-per-page="
        (value) => $emit('update-filters', { pageSize: value > 0 ? value : 20 })
      "
      @update:page="(value) => $emit('update-filters', { page: value })"
    >
      <template #item="{ item, isExpanded, expand }">
        <tr class="row-click">
          <td @click="expand(!isExpanded)">
            <div class="d-flex flex-column ma-2 justify-center">
              <BaseParagraph
                v-if="item.client"
                class="mb-2"
                v-text="item.client.email"
              />
              <BaseParagraph
                v-if="item.client"
                type="secondary"
                v-text="
                  item.client.firstName || item.client.lastName
                    ? `${item.client.firstName} ${item.client.lastName}`
                    : '-'
                "
              />

              <BaseParagraph v-else v-text="item.email" />
            </div>
          </td>
          <td @click="expand(!isExpanded)">
            <BaseParagraph
              v-text="$d(new Date(item.dateCreated), 'veryshort')"
            />
          </td>
          <td v-if="!item.answer" @click="expand(!isExpanded)">
            <BaseParagraph
              v-text="
                item.nextReminderDate
                  ? $d(new Date(item.nextReminderDate), 'veryshort')
                  : ''
              "
            />
          </td>
          <td @click="expand(!isExpanded)">
            <BaseButtonIcon
              :class="{
                'openRecord-enter-active': !isExpanded,
                'openRecord-leave-active': isExpanded,
              }"
              icon="$mdiChevronDown"
            />
          </td>
        </tr>
      </template>
      <template #expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <div class="my-4">
            <Record
              v-if="/^AGREED$/.test(recordStatus)"
              :record-id="item.id"
              :record="item"
            />
            <div v-else class="record_inprogress">
              <div class="message">
                <BaseParagraph
                  class="ml-auto mb-2 d-block"
                  text="primary"
                  v-text="$t('client.notFinishedLabel')"
                />
              </div>
              <div class="actions">
                <BaseButton
                  type="primary"
                  color="purple"
                  class="d-flex align-center"
                  @click="openRelaunchModal({ item, isDisagree: false })"
                >
                  <BaseIcon
                    icon="$mdiEmailOutline"
                    color="purple"
                    class="mr-2"
                  />
                  <BaseParagraph
                    bold
                    text="secondary"
                    color="purple"
                    v-text="$t('folder.relaunch')"
                  />
                </BaseButton>
                <BaseButton
                  color="primary"
                  type="primary"
                  @click="openReminderLogsDialog(item)"
                >
                  {{ $t("utils.showLogs") }}
                </BaseButton>
              </div>
            </div>
          </div>
        </td>
      </template>
    </v-data-table>

    <RecordRelaunchLogsDialog
      :is-open="remindLogsDialogState"
      :all-records-logs="recordReminderLogs"
      @close="remindLogsDialogState = false"
    />
  </div>
</template>

<script>
import Record from "@/core/Components/Record";
import RecordRelaunchLogsDialog from "@/modules/Folder/Components/RecordRelaunchLogsDialog.vue";

export default {
  name: "CampaignDetailRecordsList",
  components: {
    Record,
    RecordRelaunchLogsDialog,
  },
  props: {
    listHeaders: {
      type: Array,
      required: true,
    },
    records: {
      type: Array,
      default: () => [],
    },
    recordsCount: {
      type: Number,
      default: 0,
    },
    recordStatus: {
      type: String,
      default: "AGREED",
    },
    isLoadingRecords: {
      type: Boolean,
    },
  },
  data() {
    return {
      remindLogsDialogState: false,
      activeRecord: null,
    };
  },
  computed: {
    recordReminderLogs() {
      if (!this.activeRecord?.reminders?.length) return [];
      return this.activeRecord.reminders.map((record, index) => ({
        ...record,
        actionDisplay: this.$tc(
          "campaign.records.relaunchLogs",
          index === this.activeRecord.reminders.length - 1 ? 0 : 1,
          {
            clientEmail: this.activeRecord?.email,
            assignFromName:
              record.collaborator?.firstname !== "" &&
              record.collaborator?.lastname !== ""
                ? `${record.collaborator?.firstname} ${record.collaborator?.lastname}`
                : record.collaborator?.email,
          }
        ),
      }));
    },
  },
  methods: {
    openRelaunchModal(item) {
      this.$store.commit("folder/SET_RELAUNCH_DIALOG_OPEN", true);
      this.$store.commit("folder/SET_RECORD_TO_RELAUNCH", item);
    },
    openReminderLogsDialog(item) {
      this.activeRecord = item;
      this.remindLogsDialogState = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes openRecord-in {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

.openRecord-enter-active {
  animation: openRecord-in 0.5s;
}
.openRecord-leave-active {
  animation: openRecord-in 0.5s reverse;
  transform: rotate(180deg);
}
::v-deep .row-click {
  cursor: pointer;
}
.record_inprogress {
  padding: 4px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  .message {
    flex: 1;
  }
  .actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }
}
</style>
